import { useAuth0 } from '@auth0/auth0-react';
import Button, { ButtonVariant } from '@ben/orion/deprecated-button';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { CenteredContainer } from '../../components/shared/centered-container';

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  const DEVELOPMENT_ENVIRONMENT = 'development';

  const deploymentEnvironment =
    process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT || DEVELOPMENT_ENVIRONMENT;

  let redirectUri: string;

  if (deploymentEnvironment === DEVELOPMENT_ENVIRONMENT) {
    redirectUri = `${window.location.pathname}`;
  } else if (window.location.pathname.includes('/modben')) {
    redirectUri = `${window.location.pathname}`;
  } else {
    redirectUri = `/modben/${window.location.pathname}`;
  }

  return (
    <Button
      variant={ButtonVariant.primary}
      onClick={() => {
        void loginWithRedirect({
          appState: { targetUrl: redirectUri },
        }).catch(console.error);
      }}
      label="Log In"
    />
  );
};

function LoginScreen() {
  return (
    <CenteredContainer>
      <Typography
        variant={TypographyVariant.bodyLg1}
        style={{ textAlign: 'center' }}
      >
        Please log in using the following link
      </Typography>
      <LoginButton />
    </CenteredContainer>
  );
}

export default LoginScreen;
